import React from 'react'
import styled from 'styled-components'
import { Trans } from 'react-i18next'
import { useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'

const ClickableText = styled.span<{ $theme: SystemTheme }>`
  cursor: pointer;
  color: ${({ $theme }) => $theme.interaction.primary.default};
  text-decoration: underline;
  &:hover {
    color: ${({ $theme }) => $theme.interaction.primary.hover};
  }
  &:active {
    color: ${({ $theme }) => $theme.interaction.primary.pressed};
  }
`

interface AvailableSoonTooltipContentProps {
  i18nKey: string
  onClick: () => void
}

const AvailableSoonTooltipContent = ({ i18nKey, onClick }: AvailableSoonTooltipContentProps) => {
  const theme = useSysTheme()

  return (
    <span>
      <Trans
        i18nKey={i18nKey}
        components={{
          CustomLink: <ClickableText $theme={theme} onClick={onClick} />
        }}
      />
    </span>
  )
}

export default AvailableSoonTooltipContent
